import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/hooks/useSeo";
import { useHref, useT } from "@/i18n";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const href = useHref();
  const t = useT();
  const success = params.get("result") === "success";

  useSeo({ title: t("pay.seo.title") });
  const resumeUrl = !success ? localStorage.getItem("dirbiz_resume_url") : null;
  const resumePath = resumeUrl ? new URL(resumeUrl, window.location.origin).pathname : null;

  return (
    <div className="mx-auto max-w-2xl px-4 py-24 sm:px-8">
      <div
        data-testid="payment-result"
        className={`rounded-lg border p-10 text-center ${success ? "border-emerald-200 bg-emerald-50" : "border-red-200 bg-red-50"}`}
      >
        {success ? (
          <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
        ) : (
          <XCircle className="mx-auto h-12 w-12 text-red-600" />
        )}
        <h1 className="mt-5 font-display text-2xl font-bold tracking-tight">
          {success ? t("pay.success.title") : t("pay.fail.title")}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-700">
          {success ? t("pay.success.body") : t("pay.fail.body")}
        </p>
        {params.get("bill_id") && (
          <p className="mt-2 text-xs text-slate-500" data-testid="payment-bill-id">
            {t("pay.billId")}: {params.get("bill_id")}
          </p>
        )}
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link to={href("/directory")}>
            <Button data-testid="payment-directory-button" className="bg-primary hover:bg-[#0052CC]">
              {t("pay.viewDir")}
            </Button>
          </Link>
          <Link to={href(resumePath || "/submit")}>
            <Button variant="outline" data-testid="payment-retry-button">
              {resumePath ? t("pay.resume") : t("pay.backForm")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
